import { Item } from "@common/ADAPT.Common.Model/organisation/item";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { ItemPageComponent } from "./item-page.component";

export const itemPageRoute = new OrganisationPageRouteBuilder<{ itemCodeOrId: string }, Item>()
    .usingNgComponent("adapt-item-page", ItemPageComponent)
    .atOrganisationUrl("/item/:itemCodeOrId")
    .mapInputParam((item) => ({ itemCodeOrId: item.itemId.toString() }))
    .build();
